// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-container[data-v-59ac24d6] {\n  margin: 30px;\n}\n.dashboard-text[data-v-59ac24d6] {\n  font-size: 30px;\n  line-height: 46px;\n}", ""]);
// Exports
module.exports = exports;
